function waitForElement(selector, timeout = 10000) {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      observer.disconnect()
      reject(
        new Error(
          `Element with selector "${selector}" not found within timeout.`
        )
      )
    }, timeout)

    if (document.querySelector(selector)) {
      clearTimeout(timer)
      return resolve(document.querySelector(selector))
    }

    const observer = new MutationObserver((mutations) => {
      if (document.querySelector(selector)) {
        clearTimeout(timer)
        observer.disconnect()
        resolve(document.querySelector(selector))
      }
    })

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    })
  })
}

async function hideChatOnFooterIntersection() {
  // Wait for chat container to be added to the page
  const chatContainer = await waitForElement('#gorgias-chat-container')

  const footer = document.querySelector('#shopify-section-footer > footer')
  if (!footer) {
    console.warn('Footer not found. Skipping chat visibility logic.')
    return
  }

  const hideClasses = []
  if (footer.hasAttribute('data-chat-hide-mobile')) {
    hideClasses.push('hidden--mobile')
  }
  if (footer.hasAttribute('data-chat-hide-desktop')) {
    hideClasses.push('hidden--desktop')
  }

  const intersectionOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.05,
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        chatContainer.classList.add(...hideClasses)
      } else {
        chatContainer.classList.remove(...hideClasses)
      }
    })
  }, intersectionOptions)

  // Wait for footer to be visible in the viewport [threshold] amount
  observer.observe(footer)
}

hideChatOnFooterIntersection()
